var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":("设置[" + (this.category.name) + "]类的快捷方式"),"visible":true,"okText":"确认","cancelText":"取消","width":"590px"},on:{"cancel":function () {
      _vm.$emit('ok');
    },"ok":function () {
      _vm.$emit('ok');
    }}},[_c('a-transfer',{attrs:{"data-source":_vm.eventList,"show-search":"","locale":{
      itemUnit: '项',
      itemsUnit: '项',
      notFoundContent: '事件为空',
      searchPlaceholder: '搜索事件名、描述和缩写'
    },"list-style":{
      width: '250px',
      height: '300px'
    },"filter-option":_vm.filterOption,"target-keys":_vm.targetKeys,"render":function (item) { return ((item.icon) + " " + (item.title) + " - [" + (item.abbr) + "]"); }},on:{"change":_vm.handleChange,"search":_vm.handleSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }